import { render, staticRenderFns } from "./LearningReport.vue?vue&type=template&id=084bef7a&scoped=true&"
import script from "./LearningReport.vue?vue&type=script&lang=js&"
export * from "./LearningReport.vue?vue&type=script&lang=js&"
import style0 from "./LearningReport.vue?vue&type=style&index=0&id=084bef7a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "084bef7a",
  null
  
)

component.options.__file = "LearningReport.vue"
export default component.exports